<template>
    <div>
        <b-table
            :busy="isLoading"
            :fields="enrolmentAttachmentFields"
            :items="enrolmentAttachments"
            show-empty
            empty-text="No Evidence"
            borderless
            thead-class="d-none"
            tbody-tr-class="enrolment-attachment-row"
        >
            <template #cell(feedback_final_assessment)="attachment">
                <b-row>
                    <b-col>
                        <b-checkbox
                            v-model="attachment.item.final_assessment"
                            :disabled="true"
                        >
                            I used the evidence for final assessment
                            <span
                                v-if="attachment.item.final_assessment && attachment.item.final_assessment_at && attachment.item.final_assessment_by"
                            >
                                ({{ attachment.item.final_assessment_by.name }} {{ formatDate(attachment.item.final_assessment_at )}})
                            </span>
                        </b-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-checkbox
                            v-model="attachment.item.feedback"
                            :disabled="true"
                        >
                            I used the evidence to provide feedback/learning only
                            <span
                                v-if="attachment.item.feedback && attachment.item.feedback_at && attachment.item.feedback_by"
                            >
                                ({{ attachment.item.feedback_by.name }} {{ formatDate(attachment.item.feedback_at )}})
                            </span>
                        </b-checkbox>
                    </b-col>
                </b-row>
            </template>
            <template #cell(actions)="attachment">
                <b-modal
                    :id="`modal-${attachment.item.id}`"
                    size="xl"
                    :title="attachment.item.original_name"
                >
                    <video-component
                        v-if="
                            attachment.item.converted == 1 &&
                            ['mp4', 'avi', 'mov', 'webm', '3gp']
                                .includes(
                                    attachment.item.original_name.split('.').pop().toLowerCase()
                                )
                        "
                        :options="{ sources: [{src: `/enrolmentattachments/video/${attachment.item.name.split('.')[0]}.m3u8`, type: 'application/x-mpegURL'}]}"
                    />
                </b-modal>
                <span v-show="attachment.item.converted == 0 && attachment.item.failed == 0">Video Conversion in Progress</span>
                <span v-show="attachment.item.converted == 0 && attachment.item.failed == 1">Video Conversion failed</span>
                <b-btn
                    v-show="
                        attachment.item.converted == 1 &&
                        ['mp4', 'avi', 'mov', 'webm', 'wmv', '3gp']
                            .includes(
                                attachment.item.original_name.split('.').pop().toLowerCase()
                            )
                    "
                    variant="info"
                    size="sm"
                    style="color: white;"
                    v-b-modal="'modal-' + attachment.item.id"
                >
                    Preview
                </b-btn>
                <b-btn
                    v-show="
                        ['pdf', 'jpg', 'jpeg', 'gif', 'png']
                            .includes(
                                attachment.item.original_name.split('.').pop().toLowerCase()
                            )
                    "
                    variant="info"
                    size="sm"
                    style="color: white;"
                    target="_blank"
                    :href="`/enrolmentattachments/${attachment.item.id}?preview=true`"
                >
                    Preview
                </b-btn>
                <b-btn
                    v-if="attachment.item.converted == 1"
                    variant="success"
                    size="sm"
                    :href="`/enrolmentattachments/${attachment.item.id}`"
                    download
                >
                    Download
                </b-btn>
            </template>
            <template #row-details="attachment">
                <b-row
                    v-if="attachment.item.uploaded_after_final_result"
                >
                    <b-col>
                        <small>This evidence was uploaded after a final result was applied</small>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col
                        :cols="size == 'lg' ? 12 : 6"
                    >
                        <b-row>
                            <b-col>
                                <strong>Assessors Feedback</strong>
                            </b-col>
                        </b-row>
                        <b-table
                            :fields="commentFields"
                            :items="attachment.item.comments"
                            fixed
                            borderless
                            thead-class="d-none"
                        >
                            <template #cell(created_by)="row">
                                {{ row.item.created_by.name }}
                            </template>
                            <template #cell(created_at)="row">
                                {{ formatDate(row.item.created_at ) }}
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </template>
        </b-table>
        <!-- check for permission -->
        <div
            v-if="!archived"
            class="mt-3 ml-2"
        >
            <b-row>
                <b-col
                    cols="3"
                >
                    <b-form-group>
                        <b-form-file
                            v-model="attachment"
                            :accept="acceptedFormats"
                            ref="attachment"
                            placeholder="Select evidence to upload"
                            :disabled="archived || isLoading"
                        />
                    </b-form-group>
                </b-col>
                <b-col
                    align-v="center"
                >
                    <b-btn
                        @click="addAttachment(enrolment)"
                        variant="success"
                        size="sm"
                        :disabled="archived || isLoading"
                        class="mt-1"
                    >
                        Add Evidence
                    </b-btn>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        enrolment: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: "sm"
        },
        archived: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        converting() {
            this.converting.forEach((attachment) => {
                if (attachment.timer === '') {
                    attachment.timer = setInterval(() => {this.getAttachmentStatus(attachment)}, 3000);
                }
            });
        }
    },
    created() {
        this.enrolmentAttachments = this.enrolment.enrolment_attachments;
    },
    mounted() {
        this.enrolmentAttachments.forEach((et) => {
            et._showDetails = true;
            if (et.uploaded_after_final_result) {
                et._rowVariant = 'warning';
            }
        });
        this.enrolmentAttachments.forEach((att) => {
            if (att.converted == 0 && att.failed == 0) {
                this.converting.push({enrolment: this.enrolment, timer: '', ...att});
            }
        });
    },
    data() {
        return {
            enrolmentAttachments: [],
            acceptedFormats: [
                '.wmv',
                '.asf',
                '.mp4',
                '.avi',
                '.mov',
                '.webm',
                '.svg',
                '.jpg',
                '.jpeg',
                '.png',
                '.bmp',
                '.gif',
                '.tif',
                '.tiff',
                '.webp',
                '.doc',
                '.docx',
                '.csv',
                '.xls',
                '.xlsx',
                '.pdf',
                '.odf',
                '.odt',
                '.ods',
                '.odp',
                '.pub',
                '.ppt',
                '.pptx',
                '.3gp'
            ].join(','),
            attachment: null,
            converting: [],
            isLoading: false,
            enrolmentAttachmentFields: [
                { key: 'original_name', label: 'Name' },
                { key: 'feedback_final_assessment', label: 'Feedback / Final Assessment' },
                { key: 'actions', label: 'Actions' }
            ],
            commentFields: [
                { key: 'comment', label: 'Comment' },
                { key: 'created_by', label: 'Created By' },
                { key: 'created_at', label: 'Created At' },
            ],
            finalResults: ['COM', 'GCA', 'CT', 'RPL']
        }
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY');
            }

            return '';
        },
        getAttachmentStatus(attachment) {
            axios.get(`/api/enrolmentAttachments/${attachment.id}/status`)
                .then(res => {
                    if (!res.data.converting) {
                        // remove from converting list
                        const found = this.enrolmentAttachments.find((el) => el.id == attachment.id);
                        if (found) {
                            found.converted = "1";
                            found.original_name = res.data.original_name;
                            const i = this.converting.findIndex((el) => el.id == attachment.id);
                            if (i != -1) {
                                if (this.converting[i].timer !== '') {
                                    clearInterval(this.converting[i].timer);
                                }
                                this.converting.splice(1, i);
                            }
                        }
                    }
                });
        },
        addAttachment(enrolment) {
            let formData = new FormData();
            
            formData.append('attachment', this.attachment);
            formData.append('enrolment_id', enrolment.id);

            this.isLoading = true;

            axios
                .post('/api/enrolmentAttachments', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then((res) => {
                    this.attachment = null;
                    this.$refs['attachment'].reset();

                    const data = res.data.data;
                    data._showDetails = true;

                    if (data.uploaded_after_final_result) {
                        data._rowVariant = 'warning';
                    }

                    // add to enrolment attachment array
                    this.enrolmentAttachments.push(data);
                    
                    if (!data.converted) {
                        this.converting.push({enrolment, timer: '', ...data});
                    }
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        new Noty({
                            text: err.response.data.errors.attachment ? err.response.data.errors.attachment.join() : err.response.data.errors,
                            type: 'error',
                            timeout: 1000,
                        }).show();
                    } else {
                        new Noty({
                            text: 'Error Adding Attachment',
                            type: 'error',
                            timeout: 1000,
                        }).show();
                    }
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>
<style>
    .tableBorderBottom {
        border-bottom: 1px solid #8b8680;
    }

    .enrolment-attachment-row:not(.b-table-row-selected) {
        border-bottom: none;
    }

    .enrolment-attachment-row:not(.b-table-row-selected) + tr.b-table-details {
        border-bottom: 1px solid #8b8680;
    }

    .enrolment-attachment-row.b-table-row-selected {
        border-bottom: 1px solid #8b8680;
    }
</style>
